import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import {
	IOfferContext,
	IDkvContext,
	DkvContext,
	TollService,
	OfferContext,
	fetchInitialDkvData,
	getUrlBasePath,
} from '@adac-mp/shared';
import Upload from '../../components/dkv/upload';
import Registration from '../../components/dkv/registration';
import Configuration from '../../components/configuration';
export const DkvConfiguration = () => {
	const navigate = useNavigate();
	const { vehicleRegistration, inputFields } = useContext<IDkvContext>(DkvContext);
	const { offer, updateOffer, updateAllCountries, updateDkvOffers } = useContext<IOfferContext>(OfferContext);

	useEffect(() => {
		const flowID = sessionStorage.getItem('flowId');
		if (flowID) {
			sessionStorage.clear();
		}
		// TODO: fetch product in previous page; workaround because we need the offerHash
		if (!offer) {
			fetchInitialDkvData(updateDkvOffers, updateAllCountries, updateOffer);
		}
	}, []);

	const onFinished = () => {
		if (offer && vehicleRegistration && vehicleRegistration.archivePictureId) {
			const plate = inputFields.find((field) => field.documentCode === 'A');
			if (plate) {
				TollService.saveOfferDocDetails({
					documentFieldItems: inputFields.map((inputField) =>
						inputField.documentCode === 'A'
							? { ...inputField, documentValue: Array.from(inputField.documentValue).join('-') }
							: { ...inputField },
					),
					offerHash: sessionStorage.getItem('offerHash') || '',
					archivePictureId: vehicleRegistration.archivePictureId,
					licenseplate: Array.from(plate.documentValue).join('-'),
					fuelTypeId: offer.fuelTypeId,
				}).then((res) => {
					sessionStorage.setItem('offerHash', res.offerHash);
					navigate(getUrlBasePath('/camper-mautbox/checkout'));
				});
			}
		}
	};
	// Props added dynamically in Configuration component
	const componentList = [
		{
			title: 'Fahrzeugschein hochladen',
			component: <Upload key="step0" />,
		},
		{
			title: 'Daten prüfen',
			component: <Registration key="step1" />,
		},
	];

	return <Configuration componentList={componentList} supplierId={5} onFinished={onFinished} />;
};
